function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.64845 21.1563C9.32032 21.4844 9.3047 22.0703 9.65626 22.4141C10 22.7578 10.5859 22.75 10.9141 22.4219L15.6953 17.6328L20.4844 22.4219C20.8203 22.7578 21.3984 22.7578 21.7422 22.4141C22.0781 22.0625 22.0859 21.4922 21.7422 21.1563L16.9609 16.3672L21.7422 11.5859C22.0859 11.25 22.0859 10.6719 21.7422 10.3281C21.3906 9.9922 20.8203 9.98438 20.4844 10.3203L15.6953 15.1094L10.9141 10.3203C10.5859 9.9922 9.9922 9.97657 9.65626 10.3281C9.31251 10.6719 9.32032 11.2578 9.64845 11.5859L14.4375 16.3672L9.64845 21.1563Z",
  fill: "#A1A4B1"
});

function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.b7065856.svg";
export { ForwardRef as ReactComponent };